import Vue from 'vue'
import Privacy from './Index'
const PrivacyConstructor = Vue.extend(Privacy)
let vm = null
let instance = null
let instanceIndex = 0
const PrivacyInstance = function (options) {
  const box = 'privacy-out__wrapper'
  const boxId = box + '-' + instanceIndex
  options = options || {}
  options.boxId = boxId
  options.isShow = true
  document.body.style.overflow = 'hidden'
  if (!vm) {
    const div = document.createElement('div')
    div.className = box
    div.id = boxId
    document.body.appendChild(div)
    vm = new Vue({
      el: div
    })
    instanceIndex++
  }
  options.onInstanceClose = (boxId) => {
    PrivacyInstance.close(boxId)
  }
  instance = new PrivacyConstructor({
    data: options
  })
  instance.vm = instance.$mount()
  vm.$el.appendChild(instance.vm.$el)
  instance.dom = instance.vm.$el
  return instance.vm
}

PrivacyInstance.close = (id) => {
  if (id && document.getElementById(id)) {
    document.getElementById(id).innerHTML = ''
    vm = null
    document.body.style.overflow = ''
  }
}

export default PrivacyInstance
